var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupermarket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-26 0 512 512.00122",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0633,
    stopColor: "#37355a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#232543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#171b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 230.459733,
    x2: 230.459733,
    xlinkHref: "#a",
    y1: 481.8234402878,
    y2: 533.6452915746
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4286,
    stopColor: "#ffbb23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa700"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 153.9434083572,
    x2: 447.0670480342,
    xlinkHref: "#c",
    y1: 254.3022884072,
    y2: 547.4259280842
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 250.9538971002,
    x2: 182.9744231844,
    xlinkHref: "#c",
    y1: 385.0481704694,
    y2: 385.0481704694
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 144.1290668852,
    x2: 72.6181969422,
    xlinkHref: "#c",
    y1: 385.0481704694,
    y2: 385.0481704694
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 363.9586703628,
    x2: 307.4563339276,
    xlinkHref: "#c",
    y1: 385.0481704694,
    y2: 385.0481704694
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1879,
    stopColor: "#e07d07",
    stopOpacity: 0.188235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    stopColor: "#d16d1a",
    stopOpacity: 0.462745
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7853,
    stopColor: "#b9553a",
    stopOpacity: 0.784314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 275.1231184658,
    x2: 206.8210844114,
    xlinkHref: "#h",
    y1: 497.9597797704,
    y2: 85.9441674384
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 230.459733,
    x2: 230.459733,
    y1: 208.939972445,
    y2: 273.869631717
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3262,
    stopColor: "#fe4672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#fb3e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7054,
    stopColor: "#f52f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    stopColor: "#ee1a51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4003d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5838,
    stopColor: "#bd294b",
    stopOpacity: 0.584314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 154.7358039918,
    x2: 85.0535779718,
    xlinkHref: "#k",
    y1: 265.7595482322,
    y2: 199.459936999
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 114.190004609,
    x2: 105.4529718352,
    xlinkHref: "#a",
    y1: 246.7609267354,
    y2: 194.0567284028
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#05e5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5301,
    stopColor: "#13ddac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    stopColor: "#2ad1a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ac9a0"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientTransform: "matrix(.916279 -.410202 .410202 .916279 -112.023803 127.856953)",
    gradientUnits: "userSpaceOnUse",
    x1: 146.6777,
    x2: 190.9566,
    xlinkHref: "#n",
    y1: 63.2434,
    y2: 63.2434
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 413.7075231118,
    x2: 348.6693398716,
    xlinkHref: "#k",
    y1: 236.2997583188,
    y2: 204.8433683318
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 408.828878 .001216)",
    gradientUnits: "userSpaceOnUse",
    x1: 61.857,
    x2: 53.1541,
    xlinkHref: "#a",
    y1: 245.7957,
    y2: 193.2974
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientTransform: "matrix(-.916279 -.410202 -.410202 .916279 495.312404 127.856953)",
    gradientUnits: "userSpaceOnUse",
    x1: 76.1004,
    x2: 120.3793,
    xlinkHref: "#n",
    y1: 31.6461,
    y2: 31.6461
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 225.2949558788,
    x2: 258.2832304456,
    xlinkHref: "#c",
    y1: 59.5481466846,
    y2: 92.5364212514
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 230.459733,
    x2: 230.459733,
    xlinkHref: "#h",
    y1: 449.8015410382,
    y2: 503.9597196034
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m345.78125 512h-230.644531c-13.09375 0-23.710938-10.613281-23.710938-23.710938h278.066407c0 13.097657-10.613282 23.710938-23.710938 23.710938zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m361.964844 500.445312h-263.011719c-21.816406 0-40.492187-15.652343-44.304687-37.132812l-41.679688-234.773438h434.984375l-41.683594 234.773438c-3.8125 21.480469-22.484375 37.132812-44.304687 37.132812zm0 0",
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m260.1875 314.417969-3.707031 142.519531c-.339844 13.121094-11.078125 23.582031-24.203125 23.582031h-3.636719c-13.125 0-23.863281-10.460937-24.203125-23.582031l-3.707031-142.519531c-.351563-13.617188 10.585937-24.84375 24.207031-24.84375h11.042969c13.621093 0 24.558593 11.226562 24.207031 24.84375zm0 0",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m133.511719 480.523438h-6.585938c-12.1875 0-22.476562-9.0625-24.019531-21.152344l-18.179688-142.519532c-1.847656-14.472656 9.429688-27.277343 24.019532-27.277343h14.4375c12.695312 0 23.234375 9.804687 24.148437 22.464843l10.332031 142.519532c1.015626 14.023437-10.089843 25.964844-24.152343 25.964844zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m376.191406 316.851562-18.179687 142.519532c-1.542969 12.089844-11.832031 21.152344-24.019531 21.152344h-6.582032c-14.066406 0-25.167968-11.941407-24.152344-25.964844l10.328126-142.519532c.917968-12.660156 11.457031-22.464843 24.152343-22.464843h14.433594c14.589844 0 25.867187 12.804687 24.019531 27.277343zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m255.609375 500.445312h106.355469c21.820312 0 40.492187-15.652343 44.304687-37.132812l41.683594-234.773438h-434.984375l6.316406 35.582032zm0 0",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m423.523438 268.800781h-386.125c-20.65625 0-37.398438-16.742187-37.398438-37.398437v-6.910156c0-20.652344 16.742188-37.394532 37.398438-37.394532h386.125c20.652343 0 37.394531 16.742188 37.394531 37.394532v6.910156c0 20.65625-16.742188 37.398437-37.394531 37.398437zm0 0",
    fill: "url(#j)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m189.519531 268.800781h-67.355469l-25.023437-25.011719c-4.195313-3.820312-6.84375-9.296874-6.84375-15.414062 0-2.300781.382813-4.507812 1.074219-6.578125l-15.53125-34.703125h31.984375zm0 0",
    fill: "url(#l)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m131.984375 228.375c0 11.511719-9.332031 20.84375-20.84375 20.84375s-20.84375-9.332031-20.84375-20.84375 9.332031-20.84375 20.84375-20.84375 20.84375 9.332031 20.84375 20.84375zm0 0",
    fill: "url(#m)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m114.644531 238.0625c-7.355469 3.296875-15.992187 0-19.285156-7.355469l-94.082031-210.140625c-3.292969-7.359375 0-15.992187 7.359375-19.289062 7.355469-3.292969 15.992187 0 19.285156 7.359375l94.082031 210.140625c3.292969 7.355468 0 15.992187-7.359375 19.285156zm0 0",
    fill: "url(#o)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m423.523438 187.097656h-70.425782l-9.578125 21.390625c-8.453125 2.65625-14.585937 10.554688-14.585937 19.886719 0 6.015625 2.5625 11.417969 6.640625 15.222656l25.199219 25.203125h62.75c.121093 0 .246093-.007812.367187-.011719l29.753906-66.453124c-6.808593-9.242188-17.761719-15.238282-30.121093-15.238282zm0 0",
    fill: "url(#p)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m370.621094 228.375c0 11.511719-9.332032 20.84375-20.84375 20.84375-11.511719 0-20.84375-9.332031-20.84375-20.84375s9.332031-20.84375 20.84375-20.84375c11.511718 0 20.84375 9.332031 20.84375 20.84375zm0 0",
    fill: "url(#q)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m346.273438 238.0625c7.359374 3.296875 15.992187 0 19.289062-7.355469l94.078125-210.140625c3.292969-7.359375 0-15.992187-7.359375-19.289062-7.355469-3.292969-15.992188 0-19.285156 7.359375l-94.078125 210.140625c-3.296875 7.355468 0 15.992187 7.355469 19.285156zm0 0",
    fill: "url(#r)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m178.753906 78.117188 36.808594 65.046874c6.554688 11.582032 23.238281 11.582032 29.792969 0l36.8125-65.046874c6.453125-11.410157-1.789063-25.546876-14.898438-25.546876h-8.492187l6.085937-42.945312c.71875-5.082031-3.222656-9.625-8.355469-9.625h-52.09375c-5.132812 0-9.078124 4.542969-8.359374 9.625l6.085937 42.945312h-8.492187c-13.109376 0-21.351563 14.136719-14.894532 25.546876zm0 0",
    fill: "url(#s)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m49.582031 434.769531 5.066407 28.542969c3.8125 21.480469 22.488281 37.132812 44.304687 37.132812h263.011719c21.816406 0 40.492187-15.652343 44.304687-37.132812l5.066407-28.542969zm0 0",
    fill: "url(#t)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupermarket);
export default __webpack_public_path__ + "static/media/supermarket.28ea2993.svg";
export { ForwardRef as ReactComponent };